module.exports = __webpack_public_path__ + "static/img/service-text.08025da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/service-text.png
// module id = +pkb
// module chunks = 1